import React, { useState, useRef, useEffect } from "react";
import { ChevronDown } from "lucide-react";

type FilterByButtonProps = {
  options: any;
  onSelect?: (value: any) => void;
  buttonLabel?: string;
  classNames?: string;
  defaultValue?: string | null;
};

const FilterByButton: React.FC<FilterByButtonProps> = ({
  options,
  onSelect,
  buttonLabel = "Filter By",
  classNames,
  defaultValue,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState<string | null>();

  const dropdownRef = useRef<HTMLDivElement>(null);

  const handleSelect = (value: string | null) => {
    setIsOpen(false);
    onSelect && onSelect(value);
  };

  // Detect click outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (defaultValue)
      setSelected(options.find((x: any) => x?.value === defaultValue)?.label);
  }, [options, defaultValue]);

  return (
    <div className="relative flex  w-auto" ref={dropdownRef}>
      {/* Button */}
      <div
        onClick={() => setIsOpen(!isOpen)}
        className={`${classNames} flex items-center gap-2 text-sm p-2 rounded-lg min-w-[140px] sm:min-w-[160px] w-auto focus:outline-none border border-[#E2E2E2] cursor-pointer`}
      >
        <img src="/assets/images/svg/filter.svg" alt="filter" />
        <span className="w-full text-xs sm:text-sm md:text-md">
          {selected || buttonLabel}
        </span>
        <ChevronDown className="w-4 h-4" />
      </div>

      {/* Dropdown */}
      {isOpen && (
        <div className="absolute right-0 mt-10 bg-white border rounded-md shadow-lg z-50 w-48 max-h-[300px] overflow-y-auto">
          <ul className="py-2 text-sm text-gray-700">
            {options?.map((option: any) => (
              <li key={option?.value}>
                <button
                  onClick={() => {
                    setSelected(option?.label);
                    handleSelect(option?.value);
                  }}
                  className="w-full text-left px-4 py-2 hover:bg-gray-100"
                >
                  {option?.label}
                </button>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default FilterByButton;
